import vue from 'vue'
import { createNamespacedStoreExposer } from '~/plugins/common/vuex/vuex-helper'
export const FETCH_DS_ITEMS = 'FETCH_DS_ITEMS'

const state = () => ({

  /** 전시 상품정보 저장 store
   * key : products_(구좌ID : exhCmptmtId)_(소재ID : exhMtrlNo)
   * value : 구좌, 소재별 상품리스트(Array)
  */
  material: {},

  // 대/중/소 카테고리 id
  dynamicId: {},
  // 대카테고리 id
  lgCtgrNo: '', // 대 카테고리
  mdCtgrNo: '', // 중 카테고리
  smCtgrNo: '', // 소 카테고리
  // 대카테고리명
  storeCtNm: '',

  /**
   * 필터링된 묶음 상품 번호 목록
   */
  filtetedBundleProducts: null,

  /**
   /* 휴일배송 여부 및 날짜
   */
  holidayDeliveryInfo: {},

  /**
   * 오늘배송 전문관 로그인 전 팝업에서 검색한 오늘배송 가능 주소지
   */
  quickOrderDeliveryFormShow: {},

  /**
   * 대량주문 전문관 로그인 전 팝업에서 검색한 대량주문 가능 주소지
   */
  bulkOrderDeliveryFormShow: {},

  /**
   * 배송게이트 안내페이지 뒤로가기시 베스트상품 배송유형 저장
   */
  bestSpbkSecd: '',

  /**
   * 배송게이트 안내페이지 뒤로가기시 신상품 배송유형 저장
   */
  newSpbkSecd: '',

  slideIndex: 0,

  /**
   * 배송게이트 안내페이지 뒤로가기시 활성 칩 저장
   */
  shippingActiveTab: '',

  /**
   * 전체 카테고리 목록 (BreadCrumb 드롭다운용)
   */
  allCategoryList: [],

  /**
   * 신상품 고득점 상품 카테고리 목록 (API에서 추출된 카테고리)
   */
  newProductCategories: [],
})

const mutations = ({
  /**
   * 구좌별 상품 리스트 저장 업데이트
   * @param {*} state 저장소 정보(state.material)
   * @param {Array} productList 업데이트할 신규 데이터
   * @param {String} 저장소 키  => 구좌ID : exhCmptmtId
   *                              products_(구좌ID : exhCmptmtId)_(소재ID : exhMtrlNo)
   */
  setDsMaterials (state, { productObj, exhCmptmtId }) {
    const existingKey = Object.keys(state.material).find((name) => {
      return name.includes(exhCmptmtId)
    })
    if (existingKey) {
      for (const [key, value] of Object.entries(productObj)) {
        vue.set(state.material[existingKey], key, value)
      }
    } else {
      vue.set(state.material, exhCmptmtId, productObj)
    }
  },
  /**
   * 전시 구좌별 상품 정보 초기화
   * @param {*} state
   * @param {String} 저장소 키  => 구좌ID : exhCmptmtId
   */
  initDsMaterial (state, exhCmptmtId) {
    vue.set(state.material, exhCmptmtId, {})
  },
  resetState (state, exhCmptmtId) {
    delete state.material[exhCmptmtId]
  },

  // 동적 라우팅으로 받아온 대/중/소 카테고리 id 업데이트
  setDynamicId (state, id) {
    state.dynamicId = id
  },
  // 대카테고리 id 업데이트
  setLgCtgrNo (state, obj) {
    for (const [key, value] of Object.entries(obj)) {
      state[key] = value
    }
  },
  // 카테고리 페이지명 업데이트
  setCtgrPgNm (state, name) {
    state.storeCtNm = name
  },

  /**
   * 필터링된 묶음 상품 번호 목록 저장
   */
  setFiltetedBundleProducts (state, filtetedBundleProducts) {
    state.filtetedBundleProducts = filtetedBundleProducts
  },

  /**
   * 휴일배송 여부 및 휴일배송 가능일자 정보 저장
   */
  setHolidayDeliveryInfo (state, obj) {
    state.holidayDeliveryInfo = obj
  },

  /**
   * 오늘배송 전문관 로그인 전 팝업에서 검색한 오늘배송 가능 주소지
   */
  setQuickOrderDeliveryFormShow (state, obj) {
    state.quickOrderDeliveryFormShow = obj
  },

  /**
   * 대량주문 전문관 로그인 전 팝업에서 검색한 대량주문 가능 주소지
   */
  setBulkOrderDeliveryFormShow (state, obj) {
    state.bulkOrderDeliveryFormShow = obj
  },

  /**
   * 배송게이트 안내페이지 뒤로가기시 베스트상품 배송유형 저장
   */
  setBestSpbkSecd (state, val) {
    state.bestSpbkSecd = val
  },

  /**
   * 배송게이트 안내페이지 뒤로가기시 신상품 배송유형 저장
   */
  setNewSpbkSecd (state, val) {
    state.newSpbkSecd = val
  },

  setSlideIndex (state, idx) {
    state.slideIndex = idx
  },

  /**
   * 배송게이트 안내페이지 뒤로가기시 활성 칩 저장
   */
  setShippingActiveTab (state, val) {
    state.shippingActiveTab = val
  },

  /**
   * 전체 카테고리 목록 저장
   */
  setAllCategoryList (state, categoryList) {
    state.allCategoryList = categoryList
  },

  /**
   * 신상품 고득점 상품 카테고리 목록 업데이트
   */
  setNewProductCategories (state, categories) {
    state.newProductCategories = categories
  },
})

const actions = ({
  /**
   * state 저장상태 초기값 세팅
   * @param {*} key 저장소 키  => 구좌ID : exhCmptmtId
   */
  initProductKey ({ commit }, exhCmptmtId) {
    commit('initDsMaterial', exhCmptmtId)
  },
  async fetchCtgrData ({ commit, state }) {
    try {
      const lgCtgrNum = state.lgCtgrNo
      const mdCtgrNum = state.mdCtgrNo
      const smCtgrNum = state.smCtgrNo
      let lgCtgrList = []
      let mdCtgrList = []
      let smCtgrList = []
      if (lgCtgrNum !== '') {
        lgCtgrList = await this.$api.post('/ds/ctgr', { exhCtgrNos: ['CTGR_00001'] }).then((res) => { return res.data.data })
      }
      if (mdCtgrNum !== '') {
        mdCtgrList = await this.$api.post('/ds/ctgr', { exhCtgrNos: [lgCtgrNum] }).then((res) => { return res.data.data })
      }
      if (smCtgrNum !== '') {
        smCtgrList = await this.$api.post('/ds/ctgr', { exhCtgrNos: [mdCtgrNum] }).then((res) => { return res.data.data })
      }
      const largeCategory = lgCtgrList.length > 0 && lgCtgrList.find(item => item.exhCtgrNo === lgCtgrNum)
      const middleCategory = mdCtgrList.length > 0 && mdCtgrList.find(item => item.exhCtgrNo === mdCtgrNum)
      const smallCategory = smCtgrList.length > 0 && smCtgrList.find(item => item.exhCtgrNo === smCtgrNum)

      // 활성화된 카테고리 페이지명
      if (largeCategory) {
        commit('setCtgrPgNm', largeCategory.exhCtgrNm)
      } else {
        commit('setCtgrPgNm', '전체')
      }
      return {
        ...(largeCategory && { lgCtgr: state.lgCtgrNo, lgCtgrNm: largeCategory.exhCtgrNm }),
        ...(middleCategory && { mdCtgr: state.mdCtgrNo, mdCtgrNm: middleCategory.exhCtgrNm }),
        ...(smallCategory && { smCtgr: state.smCtgrNo, smCtgrNm: smallCategory.exhCtgrNm })
      }
    } catch (error) {
      console.error('API 호출 중 오류 발생:', error)
    }
  },

  /**
   * 대카테고리 데이터 조회 (카테고리 페이지명 반환)
   */
  async fetchLgCtgrData ({ commit, state }) {
    try {
      const lgCtgrNum = state.lgCtgrNo
      if (lgCtgrNum !== '') {
        const lgCtgrList = await this.$api.post('/ds/ctgr', { exhCtgrNos: ['CTGR_00001'] }).then((res) => { return res.data.data })
        const largeCategory = lgCtgrList.length > 0 && lgCtgrList.find(item => item.exhCtgrNo === lgCtgrNum)

        // 활성화된 카테고리 페이지명
        if (largeCategory) {
          commit('setCtgrPgNm', largeCategory.exhCtgrNm)
          return largeCategory.exhCtgrNm
        }
      }
      commit('setCtgrPgNm', '전체')
      return '전체'
    } catch (error) {
      console.error('대카테고리 조회 중 오류 발생:', error)
      return '전체'
    }
  },

  /**
   * 전체 카테고리 목록 조회 (BreadCrumb 드롭다운용)
   */
  async fetchAllCategoryList ({ commit, state }) {
    // 이미 조회된 경우 재조회하지 않음
    if (state.allCategoryList.length > 0) {
      return state.allCategoryList
    }

    try {
      const categoryList = []
      const reqMidCtgrList = []
      const tempList = []

      // 1. 전체 대카테고리 조회
      const ctgrList = await this.$api.post('/ds/ctgr', { exhCnrId: '' }).then((res) => { return res.data.data })

      // 2. 대카테고리 + 중카테고리 구조 생성
      ctgrList.forEach((item, i) => {
        const newItem = {
          id: i,
          menu: item.ctgrLayerNm,
          link: item.pcLinkUrl,
          exhCtgrNo: item.exhCtgrNo,
          subMenu: []
        }

        // 신상 카테고리 추가 (상품권 제외)
        const obj = {
          menu: '신상',
          exhCtgrNo: 'newPd',
          uprExhCtgrNo: newItem.exhCtgrNo,
          link: '/ds/exhCtgr/C208/' + newItem.exhCtgrNo + '?newPdYn=Y',
          subList: []
        }

        const mdCtgrList = item.exhCtgrNo !== 'CTGR_00847'
          ? [obj, ...item.childCategories]
          : item.childCategories

        // 중카테고리 세팅
        mdCtgrList.forEach((mdItem) => {
          const newMdItem = {
            menu: mdItem.menu || mdItem.ctgrLayerNm,
            link: mdItem.link || mdItem.pcLinkUrl,
            exhCtgrNo: mdItem.exhCtgrNo,
            uprExhCtgrNo: mdItem.uprExhCtgrNo,
            subList: []
          }
          reqMidCtgrList.push(mdItem.exhCtgrNo)
          newItem.subMenu.push(newMdItem)
        })

        categoryList.push(newItem)
      })

      // 3. 소카테고리 조회
      const smallCtgrList = await this.$api.post('/ds/ctgr', { exhCtgrNos: reqMidCtgrList }).then((res) => { return res.data.data })

      smallCtgrList.forEach((item) => {
        const newItem = {
          link: item.pcLinkUrl,
          menu: item.ctgrLayerNm,
          exhCtgrNo: item.exhCtgrNo,
          uprExhCtgrNo: item.uprExhCtgrNo
        }
        tempList.push(newItem)
      })

      // 4. 소카테고리를 중카테고리에 연결
      categoryList.forEach((lItem, index) => {
        lItem.subMenu.forEach((mItem, mIndex) => {
          for (let i = 0; i < tempList.length; i++) {
            if (mItem.exhCtgrNo === tempList[i].uprExhCtgrNo) {
              categoryList[index].subMenu[mIndex].subList.push(tempList[i])
            }
          }

          // 특정 대카테고리의 특정 중카테고리에 신상 추가
          if (lItem.exhCtgrNo === 'CTGR_00022' && mItem.exhCtgrNo === 'CTGR_01020') {
            const newItem = {
              link: `/ds/exhCtgr/C208/${lItem.exhCtgrNo}/${mItem.exhCtgrNo}?newPdYn=Y`,
              menu: '신상',
              exhCtgrNo: 'newPd',
              uprExhCtgrNo: mItem.exhCtgrNo
            }
            categoryList[index].subMenu[mIndex].subList.splice(1, 0, newItem)
          }
        })
      })

      commit('setAllCategoryList', categoryList)
      return categoryList
    } catch (error) {
      console.error('전체 카테고리 조회 중 오류 발생:', error)
      return []
    }
  },

  /**
   * 신상품 고득점 상품 카테고리 목록 업데이트
   */
  updateNewProductCategories ({ commit }, categories) {
    commit('setNewProductCategories', categories)
  },
})

const getters = {
  /**
   * state 업데이트된 구좌별 데이터 조회
   * @param {*} state
   * @param {String} key 저장소 키  => 구좌ID : exhCmptmtId
   * @returns 구좌, 소재별 상품 정보 Array
   */
  getMaterialInfo: state => (exhCmptmtId) => {
    const productInfo = state.material[exhCmptmtId]
    return productInfo
  },
  /**
   * state 저장소 키 조회
   * @param {*} state
   * @param {String} exhCmptmtId 구좌별 Id
   * @returns 저장소 키  => 구좌ID : exhCmptmtId
   */
  getStoredKey: state => (exhCmptmtId) => {
    const existingKey = Object.keys(state.material).find((name) => {
      return name.includes(exhCmptmtId)
    })
    return existingKey
  },

  // 페이지에서 설정한 dynamicId Object return
  getDynamicId: state => state.dynamicId,

  // 대카고리 id return
  getLgCtgrNo: state => state.lgCtgrNo,

  // 카테고리 페이지명 return
  getCtgrPgNm: state => state.storeCtNm,

  /**
   * 필터링된 묶음 상품 번호 목록
   */
  getFiltetedBundleProducts: state => state.filtetedBundleProducts,

  /**
   * 휴일배송 여부 및 휴일배송 가능일자 정보
   */
  getHolidayDeliveryInfo: state => state.holidayDeliveryInfo,

  /**
   * 오늘배송 전문관 로그인 전 팝업에서 검색한 오늘배송 가능 주소지
   */
  getQuickOrderDeliveryFormShow: state => state.quickOrderDeliveryFormShow,

  /**
   * 대량주문 전문관 로그인 전 팝업에서 검색한 대량주문 가능 주소지
   */
  getBulkOrderDeliveryFormShow: state => state.bulkOrderDeliveryFormShow,

  /**
   * 배송게이트 안내페이지 뒤로가기시 베스트상품 배송유형 저장
   */
  getBestSpbkSecd: state => state.bestSpbkSecd,

  /**
   * 배송게이트 안내페이지 뒤로가기시 신상품 배송유형 저장
   */
  getNewSpbkSecd: state => state.newSpbkSecd,

  getSlideIndex: state => state.slideIndex,

  /**
   * 배송게이트 안내페이지 뒤로가기시 활성 칩 저장
   */
  getShippingActiveTab: state => state.shippingActiveTab,

  /**
   * 전체 카테고리 목록 조회
   */
  getAllCategoryList: state => state.allCategoryList,

  /**
   * 신상품 고득점 상품 카테고리 목록
   */
  getNewProductCategories: state => state.newProductCategories,

}

export const { storeGetters, storeActions } = createNamespacedStoreExposer('ds')(getters, actions)

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
